import { Component, Input} from '@angular/core';
import { EveReportingWidget } from '../widget.component';




@Component({
  selector: 'image-widget',
  templateUrl: 'image-widget.component.html',
  styleUrls: ['./image-widget.component.css']
})
export class ImageWidgetComponent {

  @Input()
  widget?: EveReportingImageWidget = null;


  constructor(
    
  )
  {

  }


}



export interface EveReportingImageWidget extends EveReportingWidget {
  imageSrc: string
}
